const COURSE_STATUS = {
  COMPLETED: 'COMPLETED',
  ASSIGNED: 'ASSIGNED',
  IN_PROGRESS: 'IN_PROGRESS'
};
export default {
  COURSE_STATUS
};
//# sourceMappingURL=course.js.map